export default "__VITE_ASSET__4cc8ed6e__"